<template>
  <div class="product-benefit">
    <p>
      <span class="benefit-name">{{ title }}</span>
      <slot></slot>
    </p>
  </div>
</template>

<style>
</style>

<script>
  export default{
    name: 'ProductBenefit',
    props: ['title']
  }
</script>
